module.exports = __webpack_public_path__ + "static/media/8_ball.a1f0d0d1.gif";